export const START_NEW_SUBJECT_CONVERSATION_STATE = {
  startNewConversation: true,
} as const;

export function createSubjectMessageNavigationState(initialMessage: string) {
  return {
    ...START_NEW_SUBJECT_CONVERSATION_STATE,
    initialMessage,
  } as const;
}

export function shouldStartNewSubjectConversation(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    'startNewConversation' in state &&
    state.startNewConversation === true
  );
}

export function getSubjectNavigationInitialMessage(state: unknown): string | null {
  if (
    typeof state !== 'object' ||
    state === null ||
    !('initialMessage' in state) ||
    typeof state.initialMessage !== 'string'
  ) {
    return null;
  }

  const message = state.initialMessage.trim();
  return message || null;
}
